// src/modules/app-views/account/pages/Init/modals/RemoveAccountModal/Step1.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Alert } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const NoticeStepContent = () => (
  <Alert
    title={translateX('warning')}
    style={{ width: '100%' }}
    description={translateX('remove_account_warning_step1_description')}
    type="warning"
    showIcon
  />
);

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
const noticeStep = () => ({
  stepTitle: 'notice',
  stepTooltip: 'attention',
  content: <NoticeStepContent />,
  validationFields: [], // No validation for informational step
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default noticeStep;
